// extracted by mini-css-extract-plugin
export default {"labelText":"styles_label-text__np7nb","legendText":"styles_legend-text__QjKb-"};